<template>
  <div class="_login-app">
    <div class="login">
      <div class="logo-box">
        <div class="content">
          <div class="logo-pic">
            <div class="inner-pic">
              <el-image :src="require('../assets/logo.jpg')"></el-image>
            </div>
          </div>
          <div class="app-title">{{ $store.state.sys.title }}</div>
        </div>
      </div>
      <div class="login-box">
        <el-form ref="form" :model="data" size="large" style="width: 100%;" :rules="rules"
          @keyup.enter.native="login">
          <div class="title">用户登录</div>
          <el-form-item prop="LoginId">
            <el-input prefix-icon="el-icon-user" v-model="data.LoginId" placeholder="请输入账号" />
          </el-form-item>
          <el-form-item prop="Pwd">
            <el-input prefix-icon="el-icon-lock" show-password type="password" v-model="data.Pwd"
              placeholder="请输入密码" />
          </el-form-item>
          <!-- 验证码 -->
          <div style="display: flex;">
            <div style="width: 100%;">
              <el-form-item prop="VerifyCode">
                <el-input  prefix-icon="el-icon-key" v-model="data.VerifyCode" placeholder="请输入验证码" />
              </el-form-item>
            </div>
            <div style="padding-left:10px;">
              <s-identify :identifyCode="identifyCode" @refresh="refreshCode"></s-identify>
            </div>
          </div>
          <el-button size="large" :loading="loading" type="primary" id="login_btn" @click="login">登 录</el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import sIdentify from "@/components/common/sIdentify";

export default {
  components: { sIdentify },
  data() {
    const validateCode = (rule, value, callback) => {
      if (this.identifyCode !== value) {
        this.data.VerifyCode = "";
        this.refreshCode();
        callback(new Error("请输入正确的验证码"));
      } else {
        callback();
      }
    };
    return {
      api: require("@/api/sy/user").default,
      identifyCode: "",
      loading: false,
      data: {
        LoginId: "",
        Pwd: "",
        Code: "",
        VerifyCode: "",
      },
      time: 0,
      interval: null,
      rules: {
        LoginId: [{ required: true, message: "请输入账号" }],
        Pwd: [{ required: true, message: "请输入密码" }],
        VerifyCode: [
          { required: true, message: "请输入验证码" },
          { validator: validateCode, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.refreshCode();
  },
  mounted() {
    this.$store.dispatch("getSysWebSetting");
    let token = localStorage.getItem("token");
    if (token) {
      this.$store.dispatch("refreshToken").then((res) => {
        if (res.Code == 0) {
          this.$router.push("/dashboard").catch((err) => { });
        }
      });
    }
  },
  methods: {
    login() {
      this.$refs.form.validate().then((res) => {
        if (!res) return false;
        this.loading = true;
        console.log(this.data.LoginId);

        this.$store.dispatch("login", this.data).then((res) => {
          this.$store.dispatch('getNumericSetting')
          this.$store.dispatch('getProductSetting')
          this.$store.dispatch('getSaleSetting')
          this.$store.dispatch("getPurchaseSetting");
          this.$store.dispatch("getStockSetting")
          this.$router.push("/dashboard").catch((err) => { });
        }).catch((res) => {
          this.$message.error(res.Msg);
          this.loading = false;
          console.log(res);
        });
      }).catch((res) => {
        console.log(res);
      });
    },
    refreshCode() {
      this.identifyCode = "";
      for (let i = 0; i < 4; i++) {
        this.identifyCode += this.randomNum(0, 9);
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
  },
};
</script>
<style lang="scss">
._login-app {
  height: 100vh;
  position: relative;
  overflow: hidden;

  @media screen and (min-width: 768px) {
    background-image: url("../assets/bgPic.jpg");
    background-size: 120% 120%;
    animation: gradientBG 15s ease infinite;
  }

  @keyframes gradientBG {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }

  .login {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 900px;
    height: 500px;
    display: flex;
    z-index: 1000;
    border-radius: 20px;
    box-shadow: 0 20px 60px 0 rgba(0, 0, 0, 0.3);
    overflow: hidden;
    backdrop-filter: blur(10px);
    animation: fadeInUp 0.6s ease-out;

    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translate(-50%, -40%);
      }
      to {
        opacity: 1;
        transform: translate(-50%, -50%);
      }
    }

    .logo-box {
      background:  rgba(62, 105, 199, 0.9);
      width: 45%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        width: 300px;
        height: 300px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 50%;
        top: -100px;
        right: -100px;
        animation: float 6s ease-in-out infinite;
      }

      &::after {
        content: '';
        position: absolute;
        width: 200px;
        height: 200px;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 50%;
        bottom: -50px;
        left: -50px;
        animation: float 8s ease-in-out infinite reverse;
      }

      @keyframes float {
        0%, 100% { transform: translateY(0px); }
        50% { transform: translateY(-20px); }
      }

      .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 1;

        .logo-pic {
          width: 200px;
          height: 200px;
          overflow: hidden;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.2);
          padding: 12px;
          border: 3px solid rgba(255, 255, 255, 0.3);
          box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.2);
          animation: pulse 2s ease-in-out infinite;

          @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.02); }
          }

          .inner-pic {
            width: 170px;
            height: 170px;
            overflow: hidden;
            border-radius: 50%;
            background: linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%);
            padding: 18px;
          }
        }

        .app-title {
          margin-top: 20px;
          height: 45px;
          line-height: 45px;
          font-size: 28px;
          font-weight: 600;
          text-align: center;
          color: #ffffff;
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
          letter-spacing: 3px;
        }
      }
    }

    .login-box {
      width: 55%;
      padding: 40px 45px;
      background: rgba(255, 255, 255, 0.95);
      display: flex;
      align-items: center;
      flex-direction: column;

      .title {
        color: rgba(62, 105, 199, 0.9);
        height: 55px;
        width: 100%;
        text-align: center;
        font-size: 28px;
        font-weight: 600;
        letter-spacing: 3px;
        margin-bottom: 10px;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          bottom: -8px;
          left: 50%;
          transform: translateX(-50%);
          width: 60px;
          height: 3px;
          background: linear-gradient(90deg, transparent, #667eea, transparent);
          border-radius: 2px;
        }
      }

      .el-form-item {
        margin-bottom: 20px !important;
      }

      .el-input {
        font-size: 15px;

        .el-input__inner {
          border: 2px solid #e4e7ed;
          background: #ffffff;
          border-radius: 12px;
          padding: 0 15px 0 45px;
          height: 48px;
          line-height: 48px;
          transition: all 0.3s ease;

          &:focus {
            border-color: #5789ca;
            box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
          }

          &:hover {
            border-color: #fda65f;
          }

          &::placeholder {
            color: #c0c4cc;
          }
        }

        .el-input__prefix {
          left: 15px;
          font-size: 18px;
          color: #909399;
          transition: all 0.3s ease;
        }

        .el-input__inner:focus + .el-input__prefix {
          color: #667eea;
        }
      }

      #login_btn {
        width: 100%;
        font-weight: 600;
        background: rgba(62, 105, 199, 0.9);
        font-size: 18px;
        border-radius: 12px;
        height: 48px;
        margin-top: 10px;
        border: none;
        box-shadow: 0 4px 15px 0 rgba(102, 126, 234, 0.3);
        transition: all 0.3s ease;
        letter-spacing: 2px;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px 0 rgba(102, 126, 234, 0.4);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 10px 0 rgba(102, 126, 234, 0.3);
        }
      }
    }
  }
}
</style>